<template>
  <div class="nutrients">
    <HeadLine>
      {{$ml.get('Nutrients')}}
    </HeadLine>
    <div class="body" :class="{ full : _data.length <= 1 }">

      <div v-if="nuts.length > 1" id="multiple">
        <table class="th-table">
          <tr class="head">
            <td>
              {{$ml.get('Element')}}
            </td>
            <td>
              {{$ml.get('Test Result')}}
            </td>
          </tr>

          <tr 
            v-for="(item, index) in nuts" 
            v-if="index < nuts.length / 2"
          >
            <td>
              {{ item.type }}
            </td>
            <td>
              {{ parseFloat(item.value).toFixed(2) }} {{ $ml.get(unit) }}
            </td>
          </tr>

        </table>
        <table class="th-table">

          <tr class="head">
            <td>
              {{$ml.get('Element')}}
            </td>
            <td>
              {{$ml.get('Test Result')}}
            </td>
          </tr>

          <tr 
            v-for="(item, index) in nuts" 
            v-if="index >= nuts.length / 2"
          >
            <td>
              {{ item.type }}
            </td>
            <td>
              {{ parseFloat(item.value).toFixed(2) }} {{ $ml.get(unit) }}
            </td>
          </tr>

        </table>
      </div>

      <div v-else id="single">
        <table class="th-table">

          <tr class="head">
            <td>
              {{$ml.get('Element')}}
            </td>
            <td>
              {{$ml.get('Test Result')}}
            </td>
          </tr>

          <tr 
            v-for="(item, index) in nuts" 
          >
            <td>
              {{ item.type }}
            </td>
            <td>
              {{ parseFloat(item.value).toFixed(2) }} {{ $ml.get(unit) }}
            </td>
          </tr>

        </table>
      </div>

    </div>
  </div>
</template>

<script>
import HeadLine from './../common/HeadLine';

export default {
  created() {
    console.log('nuts', this.nuts)
  },
  components: {
    HeadLine,
  },
  computed: {
    section() {
      return this.$root.data.waterTest;
    },

    nuts() {
      let interpretations = this.section['data']['interpretations'];
      return interpretations.sort(this.$sortNutrients('type'))
    },

    unit() {
      return this.$root?.data?.program?.type == 'soil-based' ? 'kg' : 'ppm';
    },
  },
}
</script>

<style lang="scss" scoped>

.nutrients {
  page-break-inside: avoid;

  .head-line {
    margin-bottom: 10px;
  }

  .body {
    display: flex;
    flex-direction: row;
    justify-content: center;

    #multiple {
      width: 100%;
      display: flex;
    }

    #single {
      width: 100%;

      .th-table {
        max-width: 100%;
      }
    }

    table {
      flex-grow: 1;
      max-width: 50%;

      &:first-child {
        margin-right: 20px;
      }
    }

    &.full .th-table {
      width: 100%;
      max-width: 100% !important;
    }
  }
}

</style>